<script setup lang="ts">
import { LoaderFullScreen } from '@brighterly/lib-lumee-ui'

import { ToastProvider } from '@shared/ui/toast'

import { useTutorKanbanStore } from '../model/store'
import TimeOffs from './TimeOffs.vue'

defineOptions({
  name: 'TutorKanbanTimeOffsPage',
})

const tutorKanbanStore = useTutorKanbanStore()

onUnmounted(() => {
  tutorKanbanStore.setTimeOffs([])
})
</script>

<template>
  <TimeOffs />
  <ToastProvider />
  <LoaderFullScreen v-if="tutorKanbanStore.isLoading" />
</template>
